import { InjectionToken } from '@angular/core';

export const FIREBASE_PROJECT_ID_PROVIDER: InjectionToken<string> =
  new InjectionToken('ProjectId');
